import classes from "./FailedIcon.module.scss";

const FailedIcon = () => {
  const outerSize = 66;
  const innerSize = 53;
  const offset = (outerSize - innerSize) / 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={outerSize}
      height={outerSize}
      viewBox={`0 0 ${outerSize} ${outerSize}`}
      fill="none"
      className={classes.failed}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={innerSize}
        height={innerSize}
        viewBox={`0 0 ${innerSize} ${innerSize}`}
        fill="none"
        x={offset}
        y={offset}
      >
        <path
          d="M41.2516 14.8628C41.6421 14.4723 41.6421 13.8392 41.2516 13.4486L39.552 11.7491C39.1615 11.3586 38.5283 11.3586 38.1378 11.7491L27.2074 22.6795C26.8169 23.07 26.1837 23.07 25.7932 22.6795L14.8628 11.7491C14.4723 11.3586 13.8392 11.3586 13.4486 11.7491L11.7491 13.4486C11.3586 13.8392 11.3586 14.4723 11.7491 14.8628L22.6795 25.7932C23.07 26.1837 23.07 26.8169 22.6795 27.2074L11.7491 38.1378C11.3586 38.5283 11.3586 39.1615 11.7491 39.552L13.4486 41.2516C13.8392 41.6421 14.4723 41.6421 14.8628 41.2516L25.7932 30.3212C26.1837 29.9307 26.8169 29.9307 27.2074 30.3212L38.1378 41.2516C38.5283 41.6421 39.1615 41.6421 39.552 41.2516L41.2516 39.552C41.6421 39.1615 41.6421 38.5283 41.2516 38.1378L30.3212 27.2074C29.9307 26.8169 29.9307 26.1837 30.3212 25.7932L41.2516 14.8628Z"
          fill="#FF4445"
        />
      </svg>
      <path
        d="M32.8889 0C26.3841 0 20.0254 1.9289 14.6168 5.54278C9.20827 9.15665 4.99281 14.2932 2.50353 20.3029C0.0142501 26.3125 -0.637059 32.9254 0.631966 39.3052C1.90099 45.685 5.03335 51.5453 9.63295 56.1448C14.2325 60.7444 20.0928 63.8768 26.4726 65.1458C32.8524 66.4149 39.4653 65.7635 45.4749 63.2743C51.4846 60.785 56.6211 56.5695 60.235 51.161C63.8489 45.7524 65.7778 39.3937 65.7778 32.8889C65.7778 24.1662 62.3127 15.8008 56.1449 9.63293C49.977 3.46507 41.6116 0 32.8889 0ZM32.8889 61.6667C27.1972 61.6667 21.6333 59.9789 16.9008 56.8167C12.1683 53.6546 8.47983 49.1601 6.3017 43.9017C4.12358 38.6432 3.55369 32.857 4.66408 27.2746C5.77448 21.6923 8.5153 16.5646 12.5399 12.5399C16.5646 8.51528 21.6923 5.77447 27.2746 4.66407C32.857 3.55367 38.6432 4.12357 43.9017 6.30169C49.1601 8.47981 53.6546 12.1683 56.8168 16.9008C59.9789 21.6333 61.6667 27.1972 61.6667 32.8889C61.6667 40.5212 58.6347 47.841 53.2379 53.2379C47.841 58.6347 40.5212 61.6667 32.8889 61.6667Z"
        fill="#FF4445"
      />
    </svg>
  );
};

export default FailedIcon;
